import React from 'react';
import { Link } from 'react-router-dom';
import Badge from './Badge';
import './JobCard.css';

const JobCard = ({ job }) => {
  const isExpiringSoon = () => {
    const last = new Date(job.lastDate);
    const today = new Date();
    const diff = (last - today) / (1000 * 60 * 60 * 24);
    return diff <= 7 && diff >= 0;
  };

  const isExpired = () => new Date(job.lastDate) < new Date();
  const jobUrl = `/job/${job.id}`;
  const organizationName = job.organization || 'Recruiting Organization';

  return (
    <div className="job-card">
      <div className="job-card-header">
        <div className="job-card-title-block">
          <div className="job-org-icon">
            {organizationName.charAt(0)}
          </div>
          <div>
            <h3 className="job-card-title">
              <Link to={jobUrl}>{job.title}</Link>
            </h3>
            <p className="job-card-org">
              <span className="org-icon">Org</span> {organizationName}
            </p>
          </div>
        </div>
        <Link to={jobUrl} className="btn-view">
          View Details
        </Link>
      </div>

      <div className="job-card-badges">
        <Badge variant="location" icon="Loc">{job.location}</Badge>
        <Badge variant="salary" icon="Rs">{job.salary}</Badge>
        <Badge variant={isExpired() ? 'default' : isExpiringSoon() ? 'date' : 'date'} icon="Date">
          Last Date: {job.lastDate}
        </Badge>
        {job.posts && (
          <Badge variant="count">{job.posts.toLocaleString()} Posts</Badge>
        )}
      </div>
    </div>
  );
};

export default JobCard;
